"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Subject_1 = require("rxjs/Subject");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var communication_action_1 = require("./communication-action");
var core_1 = require("@angular/core");
var additional_options_change_event_1 = require("../model/event/additional-options-change-event");
var report_change_event_1 = require("../model/event/report-change-event");
/**
 * Service that indicates when should be report component parts be refreshed,
 * encapsulates CommunicationService and delegates components interaction by it
 *
 * Created by pavel.arakelyan on 11/14/17.
 */
var ViewEventService = /** @class */ (function () {
    function ViewEventService(communicationService) {
        this.communicationService = communicationService;
        this.rowsChangeSource = new Subject_1.Subject();
        this.columnHighlightSource = new Subject_1.Subject();
        this.rowsChange$ = this.rowsChangeSource.asObservable();
        this.columnHighlight$ = this.columnHighlightSource.asObservable();
        this.rowElementSelected$ = this.communicationService.peerObservable.filter(function (data) {
            return data.communicationType === communication_action_1.CommunicationType.ROW_ELEMENT_SELECTED;
        });
        this.columnElementSelected$ = this.communicationService.peerObservable.filter(function (data) {
            return data.communicationType === communication_action_1.CommunicationType.COLUMN_ELEMENT_SELECTED;
        });
        this.columnsChange$ = this.communicationService.peerObservable.filter(function (data) {
            return data.communicationType === communication_action_1.CommunicationType.COLUMNS_CHANGE;
        }).map(function (data) {
            return data.event;
        });
        this.optionsPanelEvents$ = this.communicationService.peerObservable.filter(function (data) {
            return data.communicationType === communication_action_1.CommunicationType.OPTIONS_PANEL_CHANGE;
        }).map(function (data) {
            return data.event;
        });
        this.additionalOptionsChange$ = this.communicationService.peerObservable.filter(function (data) {
            return data.communicationType === communication_action_1.CommunicationType.ADDITIONAL_OPTIONS_CHANGE;
        }).map(function (data) {
            return data.event;
        });
        this.reportChange$ = this.communicationService.peerObservable.filter(function (data) {
            return data.communicationType === communication_action_1.CommunicationType.REPORT_STRUCTURE_CHANGE;
        }).map(function (data) {
            return data.event;
        });
        this.reportSetup$ = this.communicationService.peerObservable.filter(function (data) {
            return data.communicationType === communication_action_1.CommunicationType.REPORT_STRUCTURE_SETUP;
        }).map(function (data) {
            return data.event;
        });
        this.styleChange$ = this.communicationService.peerObservable.filter(function (data) {
            return data.communicationType === communication_action_1.CommunicationType.STYLE_CHANGE;
        }).map(function (data) {
            return data.event;
        });
    }
    ViewEventService.prototype.rowsChanged = function (change) {
        this.rowsChangeSource.next(change);
    };
    ViewEventService.prototype.columnsChanged = function (event) {
        this.communicationService.peerSubject.next({ event: event, communicationType: communication_action_1.CommunicationType.COLUMNS_CHANGE });
    };
    ViewEventService.prototype.columnHighlighted = function (change) {
        this.columnHighlightSource.next(change);
    };
    ViewEventService.prototype.rowElementSelected = function (rowView, path) {
        this.communicationService.peerSubject.next({ rowView: rowView, pathHolder: path, communicationType: communication_action_1.CommunicationType.ROW_ELEMENT_SELECTED });
    };
    ViewEventService.prototype.resetElementSelection = function () {
        this.rowElementSelected(null, null);
    };
    ViewEventService.prototype.resetColumnElementSelection = function () {
        this.columnElementSelected(null, null);
    };
    ViewEventService.prototype.columnElementSelected = function (columnView, path) {
        this.communicationService.peerSubject.next({ columnView: columnView, pathHolder: path, communicationType: communication_action_1.CommunicationType.COLUMN_ELEMENT_SELECTED });
    };
    ViewEventService.prototype.additionalOptionsChanged = function (title, dataSetId, filterTreeDto) {
        this.communicationService.peerSubject.next({
            event: new additional_options_change_event_1.AdditionalOptionsChangeEvent(title, dataSetId, filterTreeDto),
            communicationType: communication_action_1.CommunicationType.ADDITIONAL_OPTIONS_CHANGE
        });
    };
    ViewEventService.prototype.reportChanged = function (reportTableView, datasetId) {
        this.communicationService.peerSubject.next({
            event: new report_change_event_1.ReportChangeEvent(reportTableView, datasetId),
            communicationType: communication_action_1.CommunicationType.REPORT_STRUCTURE_CHANGE,
        });
    };
    ViewEventService.prototype.reportSetup = function (reportTableView, datasetId) {
        this.communicationService.peerSubject.next({
            event: new report_change_event_1.ReportChangeEvent(reportTableView, datasetId),
            communicationType: communication_action_1.CommunicationType.REPORT_STRUCTURE_SETUP,
        });
    };
    ViewEventService.prototype.styleChanged = function () {
        this.communicationService.peerSubject.next({
            event: {},
            communicationType: communication_action_1.CommunicationType.STYLE_CHANGE
        });
    };
    ViewEventService.prototype.notifyPageBuilder = function () {
        this.communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.PREVIEW));
    };
    ViewEventService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_dynamic_controls_metadata_1.CommunicationService])
    ], ViewEventService);
    return ViewEventService;
}());
exports.ViewEventService = ViewEventService;
//# sourceMappingURL=view-event.service.js.map